import {queryResource, getResourceCategoryList} from './api'

import PageWrapper from '../models/page.model'
import CommonTree from '../models/commonTree'
import QueryResourceParams from './models/queryResourceParams'
import ResourceItem from './models/resourceItem'

export default class UploadService {
    queryResource = async (params:QueryResourceParams, url?): Promise<PageWrapper<ResourceItem>> => {
        let { data } = await queryResource(params, url);
        let resourceList = data.content && data.content.length && data.content.map((resourceItem) => new ResourceItem(resourceItem));
        return new PageWrapper<ResourceItem>({...data, resourceList});
    };
    // 获取资源分类列表
    getResourceCategoryList=async(url?)=>{
        let { data } = await getResourceCategoryList(url);
        let list = data && data.length && data.map(item => new CommonTree(item))
        return list
    }
}